import { render, staticRenderFns } from "./BaseCounter.vue?vue&type=template&id=e6574e30&scoped=true&"
import script from "./BaseCounter.vue?vue&type=script&lang=ts&"
export * from "./BaseCounter.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCounter.vue?vue&type=style&index=0&id=e6574e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6574e30",
  null
  
)

export default component.exports